/**
 * withReviews
 * HOC for wrapping the provided component with ReviewsProvider
 */

import React from 'react'

import ReviewsProvider from './reviews-provider'

export default function withReviews (WrappedComponent) {
  return function ReviewsProviderHOC(props) {
    return (
      <ReviewsProvider>
        <WrappedComponent {...props} />
      </ReviewsProvider>
    )
  }
}
